import React from "react";
import { motion } from "framer-motion";

export default function AboutUs() {
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <div className="relative bg-gray-100 min-h-screen px-4 py-12">
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="max-w-6xl mx-auto space-y-16"
      >

        {/* HERO */}
        <motion.div variants={item} className="bg-white shadow-xl rounded-2xl p-10 text-center hover:shadow-2xl transition">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Welcome to ProWave Venture</h1>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Your trusted neighborhood provision store in Abakaliki, Nigeria. We provide everyday food items, beverages, snacks, and household essentials for families in our community.
          </p>
        </motion.div>

        {/* PRODUCTS SECTION */}
        <motion.div variants={item} className="space-y-6">
          <h2 className="text-3xl font-bold text-gray-800 text-center mb-6">Our Provisions</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <motion.div whileHover={{ scale: 1.05 }} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img src="https://images.unsplash.com/photo-1601597111158-2fceff292cdc?auto=format&fit=crop&w=500&q=60" alt="Food Essentials" className="h-52 w-full object-cover"/>
              <div className="p-6">
                <h3 className="font-semibold text-lg">Food Essentials</h3>
                <p className="text-gray-600 text-sm">Rice, noodles, bread, canned foods, and other common kitchen items used in Nigerian homes.</p>
              </div>
            </motion.div>

            <motion.div whileHover={{ scale: 1.05 }} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img src="https://images.unsplash.com/photo-1586201375761-83865001e31c?auto=format&fit=crop&w=500&q=60" alt="Snacks and Beverages" className="h-52 w-full object-cover"/>
              <div className="p-6">
                <h3 className="font-semibold text-lg">Snacks & Beverages</h3>
                <p className="text-gray-600 text-sm">Biscuits, soft drinks, bottled water, juice, sweets, and other quick snacks.</p>
              </div>
            </motion.div>

            <motion.div whileHover={{ scale: 1.05 }} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img src="https://images.unsplash.com/photo-1579113800032-c38bd7635818?auto=format&fit=crop&w=500&q=60" alt="Household Items" className="h-52 w-full object-cover"/>
              <div className="p-6">
                <h3 className="font-semibold text-lg">Household Items</h3>
                <p className="text-gray-600 text-sm">Essential items for cooking, cleaning, and daily household needs.</p>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* POPULAR NIGERIAN SNACKS */}
        <motion.div variants={item} className="space-y-6">
          <h2 className="text-3xl font-bold text-gray-800 text-center mb-6">Popular Nigerian Snacks</h2>
          <div className="grid md:grid-cols-3 gap-8">

            <motion.div whileHover={{ scale: 1.05 }} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1632971641764-7e9a9f8c0e29?auto=format&fit=crop&w=500&q=60"
                alt="Chin Chin"
                className="h-52 w-full object-cover"
              />
              <div className="p-6">
                <h3 className="font-semibold text-lg">Chin Chin</h3>
                <p className="text-gray-600 text-sm">A crunchy Nigerian snack loved by kids and adults alike.</p>
              </div>
            </motion.div>

            <motion.div whileHover={{ scale: 1.05 }} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1611837658532-4cc2321fcb1f?auto=format&fit=crop&w=500&q=60"
                alt="Puff Puff"
                className="h-52 w-full object-cover"
              />
              <div className="p-6">
                <h3 className="font-semibold text-lg">Puff Puff</h3>
                <p className="text-gray-600 text-sm">Soft, fluffy, and sweet fried dough snacks, a classic Nigerian treat.</p>
              </div>
            </motion.div>

            <motion.div whileHover={{ scale: 1.05 }} className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1629982032693-1121b86b7c8b?auto=format&fit=crop&w=500&q=60"
                alt="Buns"
                className="h-52 w-full object-cover"
              />
              <div className="p-6">
                <h3 className="font-semibold text-lg">Buns</h3>
                <p className="text-gray-600 text-sm">Delicious Nigerian buns, perfect for breakfast or tea time.</p>
              </div>
            </motion.div>

          </div>
        </motion.div>

        {/* TRUST SECTION */}
        <motion.div variants={item} className="bg-white rounded-2xl shadow-lg p-10 text-center hover:shadow-2xl transition">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Why Customers Trust Us</h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Built on honesty, reliability, and excellent customer service. ProWave Venture ensures quality products, a friendly shopping experience, and a welcoming environment for everyone in Abakaliki.
          </p>
        </motion.div>

        {/* CONTACT SECTION WITH MAP */}
        <motion.div variants={item} className="bg-gradient-to-r from-green-600 to-green-500 text-white rounded-2xl shadow-xl p-10 text-center hover:shadow-2xl transition space-y-4">
          <h2 className="text-3xl font-bold mb-4">Visit Our Shop</h2>
          <p className="text-lg">Stop by for your daily provisions and snacks.</p>
          <p className="font-semibold text-lg">📍 No. 3 Dr Magnus Avenue, Ngbukobe, Abakaliki, Nigeria</p>
          <p className="text-lg">📞 Contact: <span className="font-semibold">09139147774</span></p>

          {/* GOOGLE MAP */}
          <div className="mt-6 rounded-lg overflow-hidden shadow-lg">
            <iframe
              title="ProWave Venture Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3944.236389037067!2d8.108004!3d6.326846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104924b6325b0211%3A0x123456789abcdef0!2sNo.%203%20Dr%20Magnus%20Avenue%2C%20Ngbukobe%2C%20Abakaliki!5e0!3m2!1sen!2sng!4v1696340270000!5m2!1sen!2sng"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </motion.div>

      </motion.div>

      {/* FLOATING WHATSAPP BUTTON */}
      <a
        href="https://wa.me/2349139147774"
        target="_blank"
        className="fixed bottom-6 right-6 bg-green-600 text-white p-4 rounded-full shadow-lg hover:scale-110 transition transform"
      >
        💬 WhatsApp Me
      </a>

    </div>
  );
          }
